import Image from 'next/image';
import PropTypes from 'prop-types';
import cn from 'classnames';
import breakPoints from 'helpers/Styles';

const PcModelNoticeAlert = ({ type }) => (
	<>
		<div
			className={cn('notice-box', {
				usbc_included: type === 'usbc_included',
			})}
		>
			<div className={cn({ 'notice-icon': true })}>
				<Image
					draggable={false}
					src={
						type === 'usbc_included'
							? 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-exclamation-blue.svg?v=1713944876'
							: 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-exclamation-yellow.svg?v=1713945250'
					}
					alt="usbc_included"
					height={35}
					width={35}
				/>
			</div>
			{type === 'usbc_included' && (
				<div>
					Please note: That this motherboard is compatible but does not support
					USB type C headers. You are able to checkout with this item, but the
					PC will not have a functional USB Type C port on the Chassis.
				</div>
			)}
		</div>
		<style jsx>
			{`
				.notice-box {
					display: flex;
					gap: 12px;
					color: #e4e4e4;
					font-family: 'Roboto-Medium';
					letter-spacing: 0;
					border-radius: 2px;
					padding: 8px 12px;
					line-height: 1.5rem;
				}
				.usbc_included {
					border: 1px solid #0091ff;
					background-color: rgba(0, 145, 255, 0.1);
				}
				.notice-icon {
					margin-top: 4px;
				}
				@media (max-width: ${breakPoints.small}) {
					.notice-box {
						padding: 5px 12px;
					}
				}
			`}
		</style>
	</>
);

PcModelNoticeAlert.propTypes = {
	checkout: PropTypes.bool,
	type: PropTypes.oneOf(['delayed', 'removed']),
};

export default PcModelNoticeAlert;
